import React, { useState, useCallback } from "react";
import { Dropdown, Input, Menu, Modal, Radio, Space, message } from "antd";
import "./index.less";
import IconFont from "@/components/icon";
import { Avatar } from "@/baseComponents/Avatar";
import { changeEgovUrl } from "@/utils/tools";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import lodashCompact from "lodash/compact";
import { useTranslation } from "react-i18next";
import config, { ConfigEnum } from "@/config/config";
import { WorkUserInfo } from "@/types/work";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import { ContactShowType } from "@jd/focus-desktop-comps/lib/es/UserSelection/types";
import { userSelectionTabSort } from "@/types/common";
import { editTaskGroup, makeATaskGroup } from "@/api/work";
import { connect } from "dva";

// eslint-disable-next-line complexity
function TaskGroupModal({
  userData,
  setIsModalVisible,
  fetchTaskGroupsList,
  curGroupCreator = "",
  curentGroupId = "",
  title = "新建任务组",
  groupCreator = null,
  name = "",
  members = []
}: {
  userData: any;
  setIsModalVisible: (value: boolean) => void;
  fetchTaskGroupsList: () => void;
  curGroupCreator?: string;
  curentGroupId?: string;
  title?: string;
  groupCreator?: any;
  name?: string;
  members?: any[];
}) {
  const [value, setValue] = useState(members && members.length ? 1 : 0); // 任务组的权限类别 0.仅自己可见 1.公开
  const [groupMembers, setGroupMembers] = useState<any>(members || []);
  const [groupName, setGroupName] = useState<string>(name);
  const [t_chat] = useTranslation("chat");
  const { t } = useTranslation("work");
  // 编辑/创建
  const handleOk = async () => {
    if (!groupName) {
      return message.warning(t("input group name"));
    }
    if (curentGroupId) {
      const [data, err]: any = await editTaskGroup({
        groupId: curentGroupId,
        groupName,
        scope: value,
        userList:
          value === 0
            ? []
            : (groupMembers || []).map((v: any) => ({
                userId: v.userId,
                teamId: v.teamId,
                app: v.app,
                permission: v.permission
              }))
      });
      if (!err) {
        // curGroupCreateRef.current = "";
        fetchTaskGroupsList();
        setIsModalVisible(false);
        message.success("编辑成功！");
      } else {
        message.error(err);
      }
      return;
    }
    const [data, err]: any = await makeATaskGroup({
      groupName,
      scope: value,
      userList:
        value === 0
          ? []
          : groupMembers.map((v: any) => ({
              userId: v.userId,
              teamId: v.teamId,
              app: v.app,
              permission: v.permission
            }))
    });
    if (data?.groupId) {
      // curGroupCreateRef.current = "";
      // fetchTaskGroupsList();
      setIsModalVisible(false);
      message.success("新建成功！");
    } else if (err) {
      message.error(err);
    }
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleAddTaskGroupMembers = useCallback((members: any, custom?: any) => {
    setGroupMembers(members);
  }, []);

  const onChange = useCallback(
    (e: any) => {
      if (curGroupCreator && curGroupCreator !== userData?.userId) {
        return message.warning("您没有编辑权限，请联系任务组创建人");
      }
      // console.log("e.target?.value-->", e.target?.value, typeof e.target?.value);
      setValue(e.target?.value || 0);
    },
    [userData?.userId]
  );

  const removeOne = useCallback(
    (i: number) => {
      groupMembers.splice(i, 1);
      setGroupMembers([...groupMembers]);
    },
    [groupMembers]
  );

  const handleMenuItem = useCallback(
    (e, item, index) => {
      let items = [];
      if (e.key === "0") {
        items = groupMembers.map((v: any) => {
          if (v.userId === item.userId) {
            v.permission = 1;
          }
          return v;
        });
      }
      if (e.key === "1") {
        items = groupMembers.map((v: any) => {
          if (v.userId === item.userId) {
            v.permission = 0;
          }
          return v;
        });
      } else if (e.key === "2") {
        removeOne(index);
        return false;
      }
      setGroupMembers([...items]);
    },
    [groupMembers, removeOne]
  );

  const menuItems = useCallback(
    (item, index) => {
      return (
        <Menu
          onClick={(e) => {
            handleMenuItem(e, item, index);
          }}
        >
          <Menu.Item key="0">
            <IconFont type="iconic_pc_task_edit" />
            可编辑
          </Menu.Item>
          {/* <Menu.Item key="1">
            <Icon type="iconic_pc_task_view" />
            仅查看
          </Menu.Item> */}
          <Menu.Item key="2">
            <IconFont type="icondelect" />
            移除成员
          </Menu.Item>
        </Menu>
      );
    },
    [handleMenuItem]
  );

  const openUserSelect = useCallback(
    function (tempList?: WorkUserInfo[] | any) {
      let temp;
      if (Array.isArray(tempList)) {
        temp = tempList;
      }
      const { userId, teamUserInfo } = userData;
      const { ddAppId, teamId } = teamUserInfo;
      const frozenIds = (temp || []).map(
        (item) => item.userId + ":" + item.app + ":" + item.teamId
      );
      const currentUser = userId + ":" + (ddAppId || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID) + ":" + teamId;
      if (!frozenIds.includes(currentUser)) {
        frozenIds.push(currentUser);
      }
      const option: any = {
        t: t_chat,
        title: t_chat("add_member"),
        tabs: !config[ConfigEnum.EXTERNAL_CONTACTS_ORG]
          ? ["recent", "workLine", "externalContacts", "group"]
          : ["recent", "org", "workLine", "externalContacts", "group"],
        tabSort: userSelectionTabSort,
        recommendParam: {
          keyWords: "",
          aiType: ["empl"]
        },
        businessTab: {},
        frozenIds: frozenIds,
        resultUsers: lodashCompact(temp || []).map((item: any) => ({
          id: item.userId + ":" + item.app + ":" + item.teamId,
          name: item.realName,
          avatar: item.headImg,
          checked: true,
          userId: item.userId,
          teamId: item.teamId,
          visible: true,
          desc: item.titleName,
          weight: item.weight,
          processStatus: item.processStatus,
          permission: 1
        })),
        contactShowType: ContactShowType.sameTenement,
        // contactsFilterFlag: "external",
        currentUser: {
          app: ddAppId,
          pin: userId,
          teamId: teamId
        }
      };
      openUserSelectionDefaultModal(
        option,
        (data: any, close: any) => {
          // 过滤掉已选中的
          const { result } = data.data;
          if (result.length) {
            const addArr: any[] = [];
            result.forEach((r: any) => {
              if (r.id) {
                const strs = r.id.split(":");
                return addArr.push({
                  userId: strs[0],
                  teamId: strs[2],
                  app: strs[1],
                  headImg: r.avatar,
                  realName: r.name,
                  titleName: r.desc,
                  weight: r.weight,
                  processStatus: r.processStatus,
                  permission: 1
                });
              }
              const { origin } = r;
              if (origin.info) {
                addArr.push({
                  userId: origin.info.userId,
                  teamId: origin.info.teamId,
                  app: origin.info.appId || origin.info.app,
                  headImg: origin.info.headImg,
                  realName: origin.info.realName,
                  titleName: r.desc,
                  weight: r.weight,
                  processStatus: r.processStatus,
                  permission: 1
                });
              } else {
                addArr.push({
                  userId: origin.userId,
                  teamId: origin.teamId,
                  app: origin.app,
                  headImg: origin.headImg,
                  realName: origin.realName,
                  titleName: r.desc,
                  weight: r.weight,
                  processStatus: r.processStatus,
                  permission: 1
                });
              }
            });
            handleAddTaskGroupMembers(addArr);
          }
          close();
        },
        userData
      );
    },
    [handleAddTaskGroupMembers, t_chat, userData]
  );

  return (
    <Modal
      title={title}
      width={360}
      centered={true}
      visible={true}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="确认"
      cancelText="取消"
      // okButtonProps={{ disabled: rightless ? true : false }}
      wrapClassName="task-group-modal"
    >
      <ul className="forged-form">
        <li>
          <label>任务组名称</label>
          <Input
            placeholder={t("input group name")}
            maxLength={20}
            value={groupName}
            // disabled={rightless ? true : false}
            onChange={(e) => setGroupName?.(e.target.value.trim())}
          />
        </li>
        {curentGroupId && (
          <li>
            <label>任务组创建人</label>
            <div className="man">
              <Avatar
                src={changeEgovUrl(getHeadImgThumbUrl(groupCreator?.headImg, 150, 150))}
                className="avatar"
                name={groupCreator?.realName || ""}
              />
              <p>
                {groupCreator?.realName}
                <span>{groupCreator?.titleName}</span>
              </p>
            </div>
          </li>
        )}
        <li>
          <label>该任务组共享权限设置</label>
          <Radio.Group onChange={onChange} value={value}>
            <Space direction="vertical" size={0}>
              <Radio value={0}>
                <p>仅自己可见</p>
                <article>其他用户无法查看该任务组</article>
              </Radio>
              <Radio value={1}>
                <p>共享成员可见</p>
                <article>邀请的用户可以对任务组进行相关操作</article>
              </Radio>
            </Space>
          </Radio.Group>
        </li>
        {!!value && (
          <li>
            <label>
              共享任务群成员
              <b onClick={() => openUserSelect(groupMembers)}>+ 添加共享成员</b>
            </label>
            <dl className={groupMembers?.length > 0 ? "" : "empty"}>
              {(groupMembers || []).map((v: any, index: any) => (
                <dd key={v.userId}>
                  <div className="man">
                    <Avatar
                      src={changeEgovUrl(getHeadImgThumbUrl(v.headImg, 150, 150))}
                      className="avatar"
                      name={v.realName || ""}
                    />
                    <p>
                      {v.realName}
                      <span>{v.titleName}</span>
                    </p>
                  </div>
                  <Dropdown overlay={menuItems(v, index)} trigger={["click"]}>
                    <div className="operate" onClick={(e) => e.preventDefault()}>
                      <Space>
                        可编辑
                        <IconFont type="iconicon_down" style={{ fontSize: 12 }} />
                      </Space>
                    </div>
                  </Dropdown>
                </dd>
              ))}
            </dl>
          </li>
        )}
      </ul>
    </Modal>
  );
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {
    fetchTaskGroupsList() {
      return dispatch({
        type: "work/queryTaskGroupsList"
      });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskGroupModal);
